import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import i18n from '@/locales/i18n';
import VueGtag from "vue-gtag";
import VueExcelXlsx from "vue-excel-xlsx";

// Views
import Home from '@/views/Home.vue';
import Create from '@/views/Create.vue';
import Login from '@/views/Login.vue';
import P404 from '@/views/P404.vue';
import Admin from '@/views/Admin.vue';

// Layouts
import EmptyLayout from "@/layouts/EmptyLayout";
import MainLayout from "@/layouts/MainLayout";
const LAYOUT_PATH = "/";

// Detecta idioma des de la ruta
const pathLang = window.location.pathname.split('/')[1]; // 'es', 'en', etc.

const supportedLangs = ['es', 'en'];
const defaultLang = 'ca';

const locale = supportedLangs.includes(pathLang) ? pathLang : defaultLang;

localStorage.setItem('language', locale);

Vue.use(VueRouter);
Vue.use(VueExcelXlsx);

Vue.use(VueGtag, {
    config: { id: "G-CRYMT84495" }
});

// Global Data
const globalData = new Vue({ i18n, data: { $user: null } });
Vue.mixin({
    computed: {
        $user: {
            get: function () { return globalData.$data.$user; },
            set: function (newUser) { globalData.$data.$user = newUser; }
        }
    }
});

const routes = [
  // Català (idioma per defecte, sense prefix)
  {
    path: '/videos',
    component: MainLayout,
    children: [
      { path: '', name: 'home', component: Home },
      { path: 'create', name: 'create', component: Create },
      { path: 'login', name: 'login', component: Login },
      { path: 'admin10', name: 'admin10', component: Admin },
      { path: '404', name: 'P404', component: P404 },
    ]
  },

  // Castellà i Anglès amb prefix
  {
    path: '/:lang(es|en)/videos',
    component: MainLayout,
    children: [
      { path: '', name: 'home-lang', component: Home },
      { path: 'create', name: 'create-lang', component: Create },
      { path: 'login', name: 'login-lang', component: Login },
      { path: 'admin10', name: 'admin10-lang', component: Admin },
      { path: '404', name: 'P404-lang', component: P404 },
    ]
  },

  // Redirecció d'altres casos cap a català
  {
    path: '*',
    redirect: '/videos'
  }
];


const router = new VueRouter({routes, mode: 'history', base: '/'});

// Handle before each route
router.beforeEach((to, from, next) => {
  const lang = to.params.lang;
  const isCatalan = !lang && to.path.startsWith('/videos');

  // 🔁 Detectar si no és un idioma vàlid
  if (!supportedLangs.includes(lang) && !isCatalan) {
    return next('/videos'); // català per defecte
  }

  // 🗣️ Assignar idioma
  if (lang) {
    i18n.locale = lang;
  } else {
    i18n.locale = 'ca';
  }

  // 🔍 Comprovar si la ruta existeix
  if (!to.matched.length) {
    return next({ name: 'P404', replace: true });
  }

  // ✅ Si tot està bé
  next();
});

new Vue({
    router,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
